<template lang="pug">
  .results-columns
    .results-columns__row(
      v-for="(column, index) in columns"
      :key="index"
    )
      SearchResult(
        v-for="result in column"
        :key="result.id"
        v-bind="result"
        @click="($emit('select', result))"
      )
</template>

<script>
import SearchResult from '@/components/SearchResult'
export default {
  components: { SearchResult },

  props: {
    results: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      columnsCount: 3,
      averageColumnWidth: 230, // px
      listeners: {
        resize: () => this.resize()
      }
    }
  },

  mounted() {
    this.resize()
    window.addEventListener('resize', this.listeners.resize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.listeners.resize)
  },

  computed: {
    columns() {
      const { columnsCount, results } = this
      const columns = []
      const lengths = []
      for (let i = 0; i < columnsCount; i++) {
        columns.push([])
        lengths.push(0)
      }

      for (let i = 0; i < results.length; i++) {
        const result = results[i]
        const { width, height } = result.image.dimensions
        const ratio = height / width

        // First make sure that each column contains one result. From then on
        // use the shortest column.
        const columnIndex =
          i < columnsCount ? i : lengths.indexOf(Math.min(...lengths))

        columns[columnIndex].push(result)
        lengths[columnIndex] += ratio
      }

      return columns
    }
  },

  methods: {
    updateColumnsCount() {
      this.columnsCount = Math.max(
        2,
        Math.round(window.innerWidth / this.averageColumnWidth)
      )
    },

    resize() {
      this.updateColumnsCount()
    }
  }
}
</script>

<style lang="scss">
.results-columns {
  display: flex;
  flex-direction: row;
  width: 100%;

  .search-result {
    width: 100%;
    margin-bottom: 0.5rem;
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__row {
    flex: 1;
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
